import gsap from 'gsap';

function init( node ) {
	if ( ! node instanceof HTMLElement ) {
		return;
	}

	const trigger = node.querySelector( '.card-stack__trigger' );
	const cards = Array.from( node.querySelectorAll( '.card-stack__card' ) );
	const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	if ( ! trigger || ! cards ) {
		return;
	}

	let mm = gsap.matchMedia();

	// add media query for desktop only
	mm.add( '(min-width: 992px)', () => {
		if ( prefersReducedMotion ) {
			cards.forEach( ( card, index ) => {
				gsap.set( card, {
					opacity: 1,
					rotation: index * 10,
				} );
			} );

			node.classList.add( 'card-stack--introduced' );
		} else {
			// intro animation
			gsap.timeline( {
				defaults: {
					ease: 'power4.out',
					duration: 1.2,
				},
				scrollTrigger: {
					trigger: node,
					start: 'top center',
				},
			} ).fromTo(
				cards,
				{
					opacity: 0,
					x: '-25%',
					rotation: -20,
					zIndex: ( index, target, targets ) => targets.length - index,
				},
				{
					delay: 0.2,
					opacity: 1,
					x: 0,
					rotation: ( index ) => index * 10,
					stagger: {
						each: 0.35,
						from: 'end',
					},
					onComplete: () => node.classList.add( 'card-stack--introduced' ),
				}
			);
		}

		// click handler for expanding/collapsing
		const handleTriggerClick = ( e ) => {
			e.preventDefault();
			e.stopImmediatePropagation();

			node.classList.add( 'card-stack--expanding' );

			const tl = gsap.timeline( {
				defaults: {
					ease: 'power4.out',
					duration: 1,
				},
			} );

			if ( ! node.classList.contains( 'card-stack--expanded' ) ) {
				tl.to( cards, {
					rotation: 0,
				} )
					.to(
						cards,
						{
							scale: 0.9,
							width: () => `${ 100 / cards.length }%`,
						},
						'-=0.8'
					)
					.to(
						cards,
						{
							left: ( index ) => `${ index * ( 100 / cards.length ) }%`,
							stagger: 0.08,
							onComplete: () => {
								node.classList.remove( 'card-stack--expanding' );
								node.classList.add( 'card-stack--expanded' );
							},
						},
						'-=0.4'
					);
			} else {
				tl.to( cards, {
					scale: 1,
					width: '33.333%',
					duration: 0.6,
				} ).to( cards, {
					stagger: 0.08,
					rotation: ( index ) => index * 10,
					left: 'auto',
					onComplete: () => node.classList.remove( 'card-stack--expanding', 'card-stack--expanded' ),
				} );
			}
		};

		// click handler for closing when clicking outside
		const handleNodeClick = ( e ) => {
			if ( node.classList.contains( 'card-stack--expanded' ) ) {
				let { target } = e;

				while ( target && target !== node ) {
					if ( cards.includes( target ) ) {
						return;
					}

					target = target.parentNode;
				}

				trigger.click();
			}
		};

		trigger.addEventListener( 'click', handleTriggerClick );
		node.addEventListener( 'click', handleNodeClick );

		// cleanup function that will be called when the media query no longer matches
		return () => {
			trigger.removeEventListener( 'click', handleTriggerClick );
			node.removeEventListener( 'click', handleNodeClick );
			// reset any animations
			gsap.set( cards, { clearProps: 'all' } );
			node.classList.remove( 'card-stack--introduced', 'card-stack--expanding', 'card-stack--expanded' );
		};
	} );

	// add media query for mobile
	mm.add( '(max-width: 991px)', () => {
		// set default mobile style
		gsap.set( cards, {
			opacity: 1,
			transform: 'none',
		} );
		node.classList.add( 'card-stack--introduced' );

		// return cleanup function
		return () => {
			// clear all GSAP-set properties
			gsap.set( cards, { clearProps: 'all' } );
			node.classList.remove( 'card-stack--introduced' );
		};
	} );
}

document.querySelectorAll( '.card-stack' ).forEach( init );
